<!--
 * @Description: 发票信息
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-07-14 18:52:14
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2023-11-10 11:34:53
-->
<template>
  <div class="invoice-list-col-page">
    <special-head title="开票信息">
      <template #extra>
        <div v-if="userInfo?.roles?.indexOf('customer:addInvoice') !== -1 && buttons.indexOf('customer:addInvoice') > -1 && permission == 1">
          <jw-button type="text" size="small" @click="addInvoice" class="add-invoice-button"><qfei-icon-add-two-outlined />{{ $t('新建') }}</jw-button>
        </div>
      </template>
    </special-head>

    <div class="invoice-list">
      <jw-spin v-if="loading" :tip="$t('数据加载中') + '……'" class="spin-loading"> </jw-spin>
      <template v-if="addInvoiceList?.length > 0">
        <div class="invoice-list-item" v-for="item in addInvoiceList" :key="item.id">
          <special-card>
            <template #title>
              <div class="invoice-list-item-title">
                <jw-radio class="edit-delete-edit" v-model="item.isDefault" @change="defaultinvoice(item)"> {{ $t(item.isDefault ? '默认' : '设为默认') }} </jw-radio>
              </div>
            </template>

            <template #more>
              <jw-dropdown v-if="hasEditButton || hasDelButton">
                <jw-button type="text" size="small" class="handle-btn-more"><qfei-icon-more-applications-outlined /></jw-button>

                <template #content>
                  <jw-doption v-if="hasEditButton" @click="editinvoice(item)">{{ $t('修改') }}</jw-doption>
                  <jw-doption v-if="hasDelButton" @click="deleteinvoice(item)">{{ $t('删除') }}</jw-doption>
                </template>
              </jw-dropdown>
            </template>

            <div class="invoice-lis-content">
              <div class="invoice-lis-content-item">
                <span class="item-label">{{ $t('抬头类型') }}</span>
                <span class="item-value">{{ item.label || '-' }}</span>
              </div>

              <div class="invoice-lis-content-item">
                <span class="item-label">{{ $t('开票抬头') }}</span>
                <span class="item-value">{{ item.invoiceHead || '-' }}</span>
              </div>

              <div class="invoice-lis-content-item">
                <span class="item-label">{{ $t('纳税识别号') }}</span>
                <span class="item-value">{{ item.taxIdCode || '-' }}</span>
              </div>

              <div class="invoice-lis-content-item">
                <span class="item-label">{{ $t('开户银行') }}</span>
                <span class="item-value">{{ item.bank || '-' }}</span>
              </div>

              <div class="invoice-lis-content-item">
                <span class="item-label">{{ $t('开户账号') }}</span>
                <span class="item-value">{{ item.account || '-' }}</span>
              </div>

              <div class="invoice-lis-content-item">
                <span class="item-label">{{ $t('开票地址') }}</span>
                <span class="item-value">{{ item.invoiceAddress || '-' }}</span>
              </div>

              <div class="invoice-lis-content-item">
                <span class="item-label">{{ $t('备注') }}</span>
                <span class="item-value">{{ item.comment || '-' }}</span>
              </div>
              <div class="invoice-lis-content-item">
                <span class="item-label">{{ $t('创建时间') }}</span>
                <span class="item-value">{{ item.gmtCreated || '-' }}</span>
              </div>
              <div class="invoice-lis-content-item">
                <span class="item-label">{{ $t('创建人') }}</span>
                <xl-avatar v-if="item.createUserName" :avatar="{ name: item?.createUserName || '', url: item?.createUserAvatarOrigin, id: item?.createUser }" :size="20" />
                <template v-else>-</template>
              </div>
            </div>
          </special-card>
        </div>
      </template>
      <template v-else>
        <jw-empty v-if="!loading" class="eltimeline" :img-src="imgSvg"> {{ $t('tips.notDataCreat') }} </jw-empty>
      </template>
    </div>
    <!-- 编辑新增 -->
    <update-invoice-modal ref="updateInvoiceRefs" @cb="getInvoiceList"></update-invoice-modal>
    <!-- 删除提示 -->
    <template>
      <jw-modal v-model:visible="removeVisible" :ok-loading="loading" @ok="removeOk" @cancel="removeCancel" title-align="start">
        <template #title> {{ $t('温馨提示') }} </template>
        <div>{{ $t('确认移除该开票信息') }}？</div>
      </jw-modal>
    </template>
  </div>
</template>
<script setup>
import { ref, inject, onMounted, computed } from 'vue';
import useLoading from '@/hooks/loading';
import imgSvg from '@/assets/images/img-no-record.svg';
import updateInvoiceModal from './update-invoice/index.vue';
import { clientService, layoutService } from '@/api/';
import { Message } from '@arco-design/web-vue';
import { useUserStore } from '@/store';
import { useI18n } from 'vue-i18n';
import SpecialHead from '@/components/fh-detail/components/special-head/index.vue';
import SpecialCard from '@/components/fh-detail/components/special-card/index.vue';

const { loading, setLoading } = useLoading(false);

const { t } = useI18n();
const addInvoiceList = ref([]);
const updateInvoiceRefs = ref();
const customerName = inject('detailParams')?.customerName; //客户名称
const id = inject('detailParams').id;
const entity = inject('detailParams')?.entity;
const permission = inject('detailParams')?.permission; //协作人权限
const removeVisible = ref(false);
const invoiceId = ref();
const { userInfo } = useUserStore(); //用户信息
const addInvoice = () => {
  const params = {
    from: 1,
    title: t('新增开票信息'),
    list: {
      customId: id,
      custom: customerName
    }
  };
  updateInvoiceRefs.value.updateInvoiceOpen(params);
};

// 是否有编辑权限
const hasEditButton = computed(() => {
  return userInfo?.roles?.indexOf('customer:editInvoice') !== -1 && buttons.value.indexOf('customer:editInvoice') > -1 && permission.value == 1;
});

// 是否有删除权限
const hasDelButton = computed(() => {
  return userInfo?.roles?.indexOf('customer:delInvoice') !== -1 && buttons.value.indexOf('customer:delInvoice') > -1 && permission.value == 1;
});

const getInvoiceList = async () => {
  addInvoiceList.value = [];
  setLoading(true);
  console.log(id.value);
  try {
    const res = await clientService.getInvoice({ customId: id.value });
    console.log(res);
    addInvoiceList.value = res?.result;
    setLoading(false);
  } catch (e) {
    setLoading(false);
  }
};
onMounted(() => {
  getInvoiceList();
  getDetail();
});
const props = defineProps({
  moduleId: {
    type: String,
    default: ''
  }
});
const buttons = ref([]);
const getDetail = async () => {
  if (!props?.moduleId) {
    return false;
  }
  try {
    const params = {
      entity: entity.value,
      moduleId: props.moduleId,
      businessId: id.value,
      apiIndex: props.moduleId
    };
    const json = await layoutService.getDetail(params);
    if (!json.error) {
      const _buttons = [];
      json?.result?.map((b) => {
        _buttons.push(b.value);
      });
      buttons.value = _buttons;
    }
  } catch (e) {
    console.log(e);
  }
};
const defaultinvoice = async (record) => {
  // 默认开票信息
  try {
    const res = await clientService.setDefaultInvoice({ id: record.id, customId: id.value });
    console.log(res);
    if (res.error) {
      Message.error(res.error?.msg || t('操作失败'));
      return;
    }
    Message.success(t('操作成功'));
    addInvoiceList.value?.map((item) => {
      item.isDefault = false;
      if (item.id == record.id) {
        item.isDefault = true;
      }
    });
    // getInvoiceList();
  } catch (e) {
    console.log(e);
  }
};
const editinvoice = (record) => {
  //编辑
  const params = {
    from: 0,
    title: t('编辑开票信息'),
    list: {
      ...record,
      custom: customerName,
      customId: id
    }
  };
  updateInvoiceRefs.value.updateInvoiceOpen(params);
};
const deleteinvoice = (record) => {
  //删除
  invoiceId.value = record.id;
  removeVisible.value = true;
};
const removeCancel = () => {
  removeVisible.value = false;
};
const removeOk = async () => {
  setLoading(true);
  try {
    const res = await clientService.delInvoice({ id: invoiceId.value });
    console.log(res);
    setLoading(false);
    if (res.error) {
      Message.error(res.error?.msg || t('操作失败'));
      return;
    }
    Message.success(t('操作成功'));
    getInvoiceList();
    removeVisible.value = false;
  } catch (e) {
    console.log(e);
    setLoading(false);
    removeVisible.value = false;
  }
};
// 抛出方法
defineExpose({
  getInvoiceList
});
</script>
<style scoped lang="less">
@import './index.less';
</style>
